import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styles from "./ParameterSettings.local.scss";
import _ from "i18n";
import { setPriceList } from "Actions";
import { Collapse, Radio, Switch } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";

class PriceList extends Component {
  constructor(props) {
    super(props);
    let priceList = this.props.data.priceList;
    this.state = {
      categories: [
        { id: "00", label: "00. CREATION MODIF DOSSIER" },
        { id: "01", label: "01. PRODUCTION BUDGET" },
        { id: "02", label: "02. SCAN ET ADMIN" },
        { id: "03", label: "03. ORGANISATION COMPTABLE" },
        { id: "04", label: "04. ENCODAGE COMPTABLE" },
        { id: "05", label: "05. PRESTATIONS TVA" },
        { id: "06", label: "06. NETTOYAGE ET VERIFICATION COMPTABILITE" },
        { id: "07", label: "07. PRODUCTION SITUATION INTERMEDIAIRE" },
        { id: "08", label: "08. PRODUCTION BILAN" },
        { id: "09", label: "09. PRESTATIONS FISCALES" },
        { id: "10", label: "10. JUSTIFICATION DE SUBSIDES" },
        { id: "11", label: "11. CONSEILS CLIENT" },
        { id: "12", label: "12. LIQUIDATION DOSSIER" },
        { id: "13", label: "13. VALIDATION - RELECTURE" }
      ],
      prices: { ...priceList },
      activeTab: {
        id: 1,
        label: "DEG"
      }
    };
  }

  handlePriceChange = (id, event) => {
    const { dispatch, handleDisabledSave } = this.props;
    const { activeTab } = this.state;
    handleDisabledSave(false);
    const newPrice = event.target.value;
    this.setState(prevState => ({
      prices: {
        ...prevState.prices,
        [prevState.activeTab.label]: {
          ...prevState.prices[prevState.activeTab.label],
          [id]: Number(newPrice)
        }
      }
    }));
    dispatch(setPriceList(activeTab.label, id, Number(newPrice)));
  };

  render() {
    const { settingSuggestions } = this.props;
    const { categories, prices, activeTab } = this.state;
    let buTabs =
      settingSuggestions.data &&
      settingSuggestions.data.bus &&
      settingSuggestions.data.bus.map(bu => {
        return { label: bu.label, id: bu.id };
      });
    return (
      <div>
        <div
          className={styles.tab_synchronization}
          style={{ height: "fit-content" }}
        >
          <div className={styles.header}>
            <span>{_("priceList")}</span>
          </div>
          <div
            className={styles.body}
            style={{
              height: "fit-content",
              width: "100%",
              margin: 0,
              boxShadow: "none",
              border: 0
            }}
          >
            <div className={styles.filter_tab}>
              {buTabs &&
                buTabs.map(category => {
                  return (
                    <span
                      key={category.id}
                      className={`${activeTab.id === category.id &&
                        styles.active_tab}`}
                      onClick={() =>
                        this.setState({
                          activeTab: category
                        })
                      }
                    >
                      {category.label}
                    </span>
                  );
                })}
            </div>
            <div style={{ padding: "10px" }}>
              <table border="1">
                <thead>
                  <tr>
                    <th>{_("category")}</th>
                    <th>{_("price")}</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map(({ id, label }) => (
                    <tr key={id}>
                      <td style={{ textAlign: "left" }}>{label}</td>
                      <td>
                        <div style={{ position: "relative" }}>
                          <input
                            type="number"
                            value={
                              (prices[activeTab.label] &&
                                prices[activeTab.label][id]) ||
                              100
                            }
                            onChange={e => this.handlePriceChange(id, e)}
                            placeholder="0"
                            style={{ marginRight: "4px" }}
                          />
                          <span
                            style={{
                              position: "absolute",
                              right: 30,
                              top: "50%",
                              transform: "translateY(-50%)"
                            }}
                          >
                            €/h
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  parameterSettings: state.parameterSettings
});

export default connect(mapStateToProps)(PriceList);



// WEBPACK FOOTER //
// ./src/components/ParameterSettings/PriceList.js